import React, { useEffect } from 'react';

import { Outlet } from 'react-router-dom';
import { SpinnerWidgetContainer } from '@prometheus/features';

import { useSelector } from 'react-redux';
import { LoginPage } from '../LoginPage';
import { LayoutSpinner } from '../AppLayout/AppLayout.styles';

import { AppState, Status } from '@prometheus/types';

export const PrivateRoute = (props: any) => {
  const { ...passProps } = props;

  const status = useSelector<AppState, Status>(state => state.user.status);
  const loginStatus = useSelector<AppState, Status>(
    state => state.user.loginStatus
  );

  if (status === Status.IN_PROGRESS || status === Status.INITIAL) {
    return (
      <SpinnerWidgetContainer>
        <LayoutSpinner size={70} />
      </SpinnerWidgetContainer>
    );
  }

  if (status === Status.SUCCESS) {
    return <Outlet {...passProps} />;
  }

  return <LoginPage hasError={loginStatus === Status.ERROR} />;
};
